import { render, staticRenderFns } from "./invoice-exchange-edit.vue?vue&type=template&id=570cd36c"
import script from "./invoice-exchange-edit.vue?vue&type=script&lang=js"
export * from "./invoice-exchange-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports